import React, { useState, useEffect, useRef } from 'react';

const today = () => new Date().toISOString().slice(0, 10);
const daysAgo = (n) => new Date(Date.now() - n * 86400000).toISOString().slice(0, 10);

export default function ListFilters({
  startDate, endDate, onDateChange,
  maxRangeDays = 7,
  filters = [],       // [{ key, label, options: ['', 'A', 'B'], value }]
  search, onSearchChange,
  onExport,
}) {
  const [localSearch, setLocalSearch] = useState(search || '');
  const debounceRef = useRef(null);

  // Sync external search changes
  useEffect(() => { setLocalSearch(search || ''); }, [search]);

  const handleSearch = (val) => {
    setLocalSearch(val);
    clearTimeout(debounceRef.current);
    debounceRef.current = setTimeout(() => onSearchChange && onSearchChange(val), 300);
  };

  const rangeExceeded = (() => {
    if (!startDate || !endDate) return false;
    const diff = (new Date(endDate) - new Date(startDate)) / 86400000;
    return diff > maxRangeDays;
  })();

  const setPreset = (start, end) => onDateChange && onDateChange({ startDate: start, endDate: end });

  const inputStyle = {
    padding: '6px 10px', borderRadius: 6, border: '1px solid var(--border)',
    background: 'var(--bg2)', color: 'var(--text)', fontSize: 13,
  };

  return (
    <div style={{ marginBottom: 16 }}>
      <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', alignItems: 'center', marginBottom: 8 }}>
        {/* Date range */}
        <input
          type="date" value={startDate || ''} style={inputStyle}
          onChange={e => onDateChange && onDateChange({ startDate: e.target.value, endDate })}
        />
        <span style={{ color: 'var(--text3)', fontSize: 13 }}>to</span>
        <input
          type="date" value={endDate || ''} style={inputStyle}
          onChange={e => onDateChange && onDateChange({ startDate, endDate: e.target.value })}
        />

        {/* Quick presets */}
        <button className="btn btn-ghost btn-sm" onClick={() => setPreset(today(), today())}>Today</button>
        <button className="btn btn-ghost btn-sm" onClick={() => setPreset(daysAgo(6), today())}>7d</button>
        <button className="btn btn-ghost btn-sm" onClick={() => setPreset(daysAgo(29), today())}>30d</button>

        {/* Dropdown filters */}
        {filters.map(f => (
          <select
            key={f.key}
            value={f.value}
            style={{ ...inputStyle, minWidth: 110 }}
            onChange={e => f.onChange && f.onChange(e.target.value)}
          >
            {f.options.map(opt => (
              <option key={opt} value={opt}>{opt === '' ? f.label + ' (all)' : opt}</option>
            ))}
          </select>
        ))}

        {/* Search */}
        {onSearchChange !== undefined && (
          <input
            type="text" placeholder="Search..." value={localSearch} style={{ ...inputStyle, minWidth: 160 }}
            onChange={e => handleSearch(e.target.value)}
          />
        )}

        {/* Export */}
        {onExport && (
          <button className="btn btn-ghost btn-sm" onClick={onExport} style={{ marginLeft: 'auto' }}>
            📥 Export CSV
          </button>
        )}
      </div>

      {rangeExceeded && (
        <div style={{ fontSize: 12, color: 'var(--accent)', padding: '6px 10px', background: '#3d2e10', borderRadius: 6, border: '1px solid var(--accent)' }}>
          ⚠ Maximum range is {maxRangeDays} days. Showing first {maxRangeDays} days. Use Export CSV for larger ranges.
        </div>
      )}
    </div>
  );
}
